import { Helmet } from 'react-helmet';
import { useState, useEffect } from "react";
import { getDynamicIds } from "./getData";

const MetaEtiquetas = () => {
    const [metaData, setMetaData] = useState({
        title: 'Agendamiento',
        description: 'Realiza tu examen visual. Agenda tu cita online, elige tu óptica y obtén la mejor atención para tu visión.'
    });
    const [url, setUrl] = useState({});
    const [urlImagen, setUrlImagen] = useState(null);
    const cadena = { 1:'gmo', 
                     2:'eco', 
                     5:'opv' };
    const [IDs, setIDs] = useState({paisId: null, cadenaId: null});
    
    useEffect(() => {
        const { paisId, cadenaId } = getDynamicIds();
        setIDs({ paisId, cadenaId });
        const baseUrl = window.location.origin; 
        const countrySlug = paisId && cadenaId ? `${cadena[cadenaId]}-${paisId === 1 ? "pe" : paisId === 2 ? "cl" : paisId === 3 ? "co" : "ec"}` : "";
        const fullUrl = `${baseUrl}/${countrySlug}`;
        
        const metas = {
            1:{
                1: {
                    title: 'Examen visual en GMO Perú | Agenda tu cita de forma fácil',
                    description: 'Programa tu evaluación visual con los especialistas de GMO Perú. Reserva tu cita online y accede a servicios de salud visual confiables y rápidos.'
                },
                2: {
                    title: 'Agenda tu examen visual en GMO Chile | Reserva online fácil',
                    description: 'Reserva tu cita de examen visual en GMO Chile de forma rápida y sencilla. Agenda en línea y cuida tu visión con nuestros expertos en salud visual.'
                },
                3: {
                    title: 'Reserva tu cita visual en GMO Colombia | Agenda en línea fácil',
                    description: 'Solicita tu cita para examen visual en GMO Colombia de manera sencilla. Agenda online con especialistas en visión y mejora tu calidad de vida hoy.'
                },
                4: {
                    title: 'Agenda tu cita visual en GMO Ecuador | Examen rápido y seguro',
                    description: 'Reserva tu examen visual en GMO Ecuador de forma ágil. Obtén atención profesional con expertos en salud visual. Agenda online en pocos pasos.'
                }
            },
            5: {
                2: {
                    title: 'Examen de la vista | Agenta tu cita en la sucursal más cercana',
                    description: 'Da clic y agenda tu cita para el examen de la vista hoy mismo. Ubica tu sucursal más cercana y recibe apoyo de profesionales de la salud visual.'
                }
            }
        };

        if (paisId && cadenaId === 1 && fullUrl) {
            setUrlImagen(baseUrl + '/static/media/gmo_logo.2f012cd8d03f7220387a.png');
            setUrl(fullUrl);
            setMetaData(metas[cadenaId][paisId]);
        }else if (paisId && cadenaId === 2 && fullUrl){
            setUrlImagen(baseUrl + '/static/media/logo.ab16fe2fdabeef9b685f5f9cbbc34447.svg');
            setUrl(fullUrl);
        }else if (paisId && cadenaId === 5 && fullUrl){
            setUrlImagen(baseUrl + '/static/media/opticas-opv-logo.370d62e4f945e17f8b73.png');
            setUrl(fullUrl);
            setMetaData(metas[cadenaId][paisId]);
        }

    }, []);

    return (
        <Helmet>
            {/* SEO Básico */}
            <title>{metaData.title}</title>
            <meta name="description" content={metaData.description} />

            {/* Open Graph para Redes Sociales */}
            <meta property="og:title" content={metaData.title} />
            <meta property="og:description" content={metaData.description} />
            <meta property="og:image" content={urlImagen} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />

            {(IDs.cadenaId === 5 || IDs.cadenaId === 1) && (
                <link rel="canonical" href={url}/>
            )}

            {/* Twitter Cards (Opcional) */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={metaData.title} />
            <meta name="twitter:description" content={metaData.description} />
            <meta name="twitter:image" content={urlImagen} />
        </Helmet>
    );
};

export default MetaEtiquetas;
